<dms-control [dmsTraduction]="this.dmsTraduction" >
	<input type="checkbox" class="textbox" >
</dms-control>